<div class="produto-search-banner product-search">
      <form class="form form-custom" (submit)="getData()">
            <label>O que você está procurando?</label>
            <div class="input-box">
                  <div class="input-box-item input-col">
                        <input type="text" placeholder="Digite aqui..." [(ngModel)]="dataItem.nome" name="nome" />
                  </div>
                  <div class="input-box-item input-col">
                        <div class="select-item input input-categoria">
                              <combo-data-select (changeValue)="_changeCity($event)" [(ngModel)]="dataItem.produto_cidade_id" [data]="comboDestinos"></combo-data-select>
                        </div>
                  </div>
                  <div class="input-box-item">
                        <button type="submit">
                              <img src="/images/icons/search.svg" alt="Pesquisar" width="35px" height="35px" loading="lazy" />
                        </button>
                  </div>
            </div>
      </form>
      <div class="content-products" *ngIf="produtos.length > 0">
            <div class="content-products-header">
                  <div class="box">
                        <span>Lista de Serviços:</span>
                  </div>
                  <div class="box">
                        <div class="close" (click)="_close()">   
                              <img src="/images/icons/close-03.svg" alt="close" width="30px"  height="30px" loading="lazy"/>
                        </div>
                  </div>
            </div>
            <div class="content-products-content">
                  <div class="item" *ngFor="let p of produtos">
                        <produto-item [data]="p" template="2"></produto-item>
                  </div>
            </div>
      </div>
</div>  
<loader *ngIf="loader"></loader>